import "./Projects.css";

import { OrganisationTypeConstants } from "../../../constants";
import { DeveloperSingleCardWithTabsTemplate, OverdueTaskPanel } from "../../../templates";
import { UpcomingMilestonesTaskPanel } from "../../../templates/UpcomingMilestonesTaskPanel";
import { WorkflowTaskPanel } from "../../../templates/WorkflowTaskPanel";
import { Column, KanaTooltip, OverdueTasks, Row, UpcomingMilestones } from "../../../widget";
import { DashboardPieCard } from "../components";
import { useProjects } from "./useProjects";

const Projects = (): JSX.Element => {
  const {
    tabsList,
    phaseChartData,
    isLoading,
    currentUserType,
    upcomingMilestones,
    overdueTasks,
    isOverdueTasksPanelOpen,
    setIsOverdueTasksPanelOpen,
    isUpcomingMilestonesPanelOpen,
    setIsUpcomingMilestonesPanelOpen,
    workflow,
    selectedPanelTask,
    showWorkflowTaskPanel,
    handleCloseWorkflowTaskPanel,
    handleRefresh,
    refreshTasks,
    setSelectedPanelTask,
    setShowWorkflowTaskPanel,
  } = useProjects();

  const kpis = (): JSX.Element | undefined => {
    return isLoading ? (
      <Row spacingV="ml">
        <Column span={6}>
          <div className="MilestonesLoadingCard">
            <p className="body01">Upcoming milestones</p>
            <p className="body2 NoData">Loading...</p>
          </div>
        </Column>
        <Column span={4}>
          <DashboardPieCard
            title="Project phase"
            data={{}}
            tooltip={
              <KanaTooltip
                tooltipHeader="Project Phase:"
                tooltipText="Shows the number of projects by phases of their workflow."
              />
            }
            isGradient
            centerTextFont="Fraunces"
            colours="roadmap"
          />
        </Column>
        <Column span={2}>
          <div className="TasksLoadingCard">
            <p className="body01">Tasks</p>
            <p className="body2 NoData">Loading...</p>
          </div>
        </Column>
      </Row>
    ) : (
      <div className="ProjectsPageKpiContainer">
        <Row>
          <Column span={6}>
            <UpcomingMilestones
              milestones={upcomingMilestones}
              onViewAll={() => setIsUpcomingMilestonesPanelOpen(true)}
            />
          </Column>
          <Column span={4}>
            <DashboardPieCard
              title="Project phase"
              data={phaseChartData}
              tooltip={
                <KanaTooltip
                  tooltipHeader="Project phases:"
                  tooltipText="Shows the number of projects by phases of their workflow."
                />
              }
              isGradient
              centerTextFont={
                currentUserType === OrganisationTypeConstants.DEVELOPMENT_MANAGER ? "Fraunces" : "Space Grotesk"
              }
              colours="roadmap"
            />
          </Column>
          <Column span={2}>
            <OverdueTasks
              amount={overdueTasks.amount}
              label={overdueTasks.label}
              onViewAll={() => setIsOverdueTasksPanelOpen(true)}
            />
          </Column>
        </Row>
        <div>
          <OverdueTaskPanel
            show={isOverdueTasksPanelOpen}
            onClose={() => setIsOverdueTasksPanelOpen(false)}
            setSelectedPanelTask={setSelectedPanelTask}
            setShowWorkflowTaskPanel={setShowWorkflowTaskPanel}
            refreshTasks={refreshTasks}
          />
          <UpcomingMilestonesTaskPanel
            show={isUpcomingMilestonesPanelOpen}
            onClose={() => setIsUpcomingMilestonesPanelOpen(false)}
            setSelectedPanelTask={setSelectedPanelTask}
            setShowWorkflowTaskPanel={setShowWorkflowTaskPanel}
            refreshTasks={refreshTasks}
          />
          <WorkflowTaskPanel
            task={selectedPanelTask}
            currentStepUuid={selectedPanelTask?.step.uuid}
            workflow={workflow}
            show={showWorkflowTaskPanel}
            refresh={refreshTasks}
            handleRefresh={handleRefresh}
            onClose={handleCloseWorkflowTaskPanel}
          />
        </div>
      </div>
    );
  };

  return DeveloperSingleCardWithTabsTemplate({
    activeElement: "Projects",
    pageTitle: "Projects",
    tabsList,
    titlePill: "",
    developer: undefined,
    developerIcon: undefined,
    carousel: kpis(),
    backButtonText: undefined,
    handleBackClick: undefined,
    currentUserType,
  });
};

export default Projects;
